export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-9.0cb2ac88.jpg";